/**
 * IconHouseVixenFemale - Female symbol (♀) with candy heart design
 * Features: glossy candy-neon style, breathing animation, soft glow
 * Cross attached to CENTER BOTTOM of heart
 */
export function IconHouseVixenFemale({ className = '', isHovered = false }) {
  return (
    <svg
      viewBox="0 0 80 100"
      className={`transition-all duration-500 ${className}`}
      style={{
        filter: isHovered 
          ? 'drop-shadow(0 0 20px rgba(255, 77, 166, 0.8)) drop-shadow(0 0 35px rgba(139, 92, 255, 0.5))'
          : 'drop-shadow(0 0 12px rgba(255, 77, 166, 0.6)) drop-shadow(0 0 25px rgba(139, 92, 255, 0.3))'
      }}
    >
      <defs>
        {/* Main candy gradient - pink to purple */}
        <linearGradient id="femaleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF4DA6" />
          <stop offset="50%" stopColor="#8B5CFF" />
          <stop offset="100%" stopColor="#27D7FF" />
        </linearGradient>
        
        {/* Glossy highlight */}
        <linearGradient id="femaleHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.6)" />
          <stop offset="40%" stopColor="rgba(255,255,255,0.1)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
        
        {/* Soft glow filter */}
        <filter id="femaleGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <g filter="url(#femaleGlow)">
        {/* Heart shape - positioned to allow cross below */}
        <path
          d="M40 52 C18 36, 8 18, 18 8 C25 0, 35 2, 40 14 C45 2, 55 0, 62 8 C72 18, 62 36, 40 52 Z"
          fill="url(#femaleGradient)"
          className="animate-breathe"
          style={{ transformOrigin: 'center 30px' }}
        />
        
        {/* Glossy highlight on heart */}
        <path
          d="M40 45 C24 33, 16 20, 22 12 C27 6, 35 7, 40 16 C40 16, 40 16, 40 16 C35 7, 27 6, 22 12 C16 20, 24 33, 40 45 Z"
          fill="url(#femaleHighlight)"
          opacity="0.5"
        />
        
        {/* Vertical shaft of cross - attached to heart bottom center */}
        <line
          x1="40"
          y1="52"
          x2="40"
          y2="88"
          stroke="url(#femaleGradient)"
          strokeWidth="5"
          strokeLinecap="round"
        />
        
        {/* Horizontal bar of cross */}
        <line
          x1="24"
          y1="72"
          x2="56"
          y2="72"
          stroke="url(#femaleGradient)"
          strokeWidth="5"
          strokeLinecap="round"
        />
        
        {/* Small sparkle accents */}
        <circle cx="22" cy="8" r="2" fill="white" opacity="0.8">
          <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2.5s" repeatCount="indefinite" />
        </circle>
        <circle cx="58" cy="10" r="1.5" fill="white" opacity="0.6">
          <animate attributeName="opacity" values="0.6;0.2;0.6" dur="2s" repeatCount="indefinite" begin="0.5s" />
        </circle>
      </g>
    </svg>
  );
}

export default IconHouseVixenFemale;
